/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class Learner extends Component {
  // Services
  @service
  options;

  @service
  session;

  @service
  store;

  @service
  strings;

  editDialog = false;
  showAttendance = false;
  showAssessments = false;
  showTopics = false;
  showGoals = false;
  numTermsToShow = 3;

  @alias('session.school.jurisdiction')
  jurisdiction;

  // Computed property to count how many checkboxes are selected
  @computed('topics')
  get isSingleTopic() {
    let topicArrays = Object.values(this.topics || {}); // Get arrays from the object
    let allTopics = [].concat(...topicArrays); // Flatten into a single array
    return allTopics.length === 1;
  }

  // learnerSummaries is a map of subjectId to learnerSummary.
  learnerSummaries = null;
}
